
function _ready(fn) { if (document.readyState !== 'loading') { fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }
_ready(function () {
var swiper2 = new Swiper('.ingrediants_slider', {
    spaceBetween: 20,
    slidesPerView: 1,
    navigation: {
        nextEl: '.swiper-button-next.pagination_arrow',
        prevEl: '.swiper-button-prev.pagination_arrow',
    },
    pagination: {
        el: ".ingrediants_pagination",
        type: 'bullets',
        clickable: true
    },
    breakpoints: {
        1280: {
            slidesPerView: 5,
            spaceBetweenSlides: 0
        },
        1040: {
            slidesPerView: 4,
            spaceBetweenSlides: 0
        },
        768: {
            slidesPerView: 3,
            spaceBetweenSlides: 0,
            spaceBetween: 20,
        },
        300: {
            slidesPerView: 1,
            spaceBetween: 8,
            spaceBetweenSlides: 0,
             grid: {
              fill: 'row',
              rows: 2
            },
        }
    }
});

    // 16-05-2024
var P_thumbs = new Swiper ('.pdp_gallery_thumbs', {
    slidesPerView: 5,
    spaceBetween: 6,
    watchSlidesVisibility: true,
    navigation: {
        nextEl: '.swiper-button-next.gallery-thumbs_arrow',
        prevEl: '.swiper-button-prev.gallery-thumbs_arrow',
    },
    breakpoints: {
        992: {
          slidesPerView: 5,
        },
        768: {
          slidesPerView: 4,
          centeredSlides: false,
        }
      }
});
var P_slider = new Swiper ('.pdp_gallery_slider', {
    slidesPerView: 1,
    navigation: {
        nextEl: '.swiper-button-next.gallery-slider_arrow',
        prevEl: '.swiper-button-prev.gallery-slider_arrow',
    },
    pagination: {
        el: '.pdp_gallery_pagition',
        type: 'bullets',
        clickable:'true'
    },
    thumbs: {
      swiper: P_thumbs,
    },
});

    











  });

document.querySelectorAll('.Story_accordion_title').forEach(function (title) {
    title.addEventListener('click', function () {
        document.querySelectorAll('.Story_accordion_title').forEach(function (t) {
            t.classList.remove('active');
            t.setAttribute('aria-expanded', 'false');
        });
        document.querySelectorAll('.Story_accordion_content_wp').forEach(function (c) { c.style.display = 'none'; });
        var nxt = this.nextElementSibling;
        var visible = nxt && !!(nxt.offsetWidth || nxt.offsetHeight || nxt.getClientRects().length);
        if (nxt && !visible) {
            nxt.style.display = '';
            this.classList.add('active');
            this.setAttribute('aria-expanded', 'true');
        }
    });
});